import { useEffect, useState } from "react";

const MenuVertical = ({ title, children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  
  useEffect(() => {
    const checkMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    setIsMobile(checkMobile);
  }, []);

  return (
    <div className="lg:w-80 pb-2 flex flex-col items-center">
      <button 
        className="w-[90%] h-12 bg-black font-bold text-white text-center rounded-xl px-4 py-2 mb-4 mx-auto shadow-md relative cursor-pointer lg:cursor-default"
        onClick={()=>setIsOpen(!isOpen)}
        disabled={!isMobile}
      >
        {title}
      </button>
      <div className={`bg-white rounded-xl shadow-md max-h-[200px] lg:max-h-[450px] ${isOpen ? 'min-h-64 lg:max-h-[450px] p-4' : 'h-[0px] p-0'} w-60 lg:w-80 -mt-7 transition-all duration-300 ease-in-out overflow-auto shadow-gray-600`}>
        <div className={`flex flex-col items-start px-4 w-full h-full overflow-auto ${isOpen ? "flex" : "hidden"}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default MenuVertical;
